import React__default from 'react';

/**
 * This function takes inspiration from here:
 * https://github.com/Andarist/use-onclickoutside/blob/master/src/index.ts
 */ function useOnKeyboardEventOutside(ref, handler) {
    React__default.useEffect(()=>{
        if (!handler || !document) {
            return;
        }
        const listener = (event)=>{
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('keyup', listener);
        return ()=>{
            document.removeEventListener('keyup', listener);
        };
    }, [
        !handler
    ]);
}

export { useOnKeyboardEventOutside };
//# sourceMappingURL=use-on-keyboard-outside.js.map
